/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AvailableRoom
 */
export interface AvailableRoom {
    /**
     * 
     * @type {string}
     * @memberof AvailableRoom
     */
    description: string;
    /**
     * 
     * @type {number}
     * @memberof AvailableRoom
     */
    tier: number;
}

/**
 * Check if a given object implements the AvailableRoom interface.
 */
export function instanceOfAvailableRoom(value: object): value is AvailableRoom {
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('tier' in value) || value['tier'] === undefined) return false;
    return true;
}

export function AvailableRoomFromJSON(json: any): AvailableRoom {
    return AvailableRoomFromJSONTyped(json, false);
}

export function AvailableRoomFromJSONTyped(json: any, ignoreDiscriminator: boolean): AvailableRoom {
    if (json == null) {
        return json;
    }
    return {
        
        'description': json['description'],
        'tier': json['tier'],
    };
}

export function AvailableRoomToJSON(json: any): AvailableRoom {
    return AvailableRoomToJSONTyped(json, false);
}

export function AvailableRoomToJSONTyped(value?: AvailableRoom | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'description': value['description'],
        'tier': value['tier'],
    };
}

